<script setup lang="ts">
import { pageTitle } from '@partner-spa-vue/stores/LayoutStore';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { watch } from 'vue';

const props = defineProps<{
    title: string;
    description?: string;
}>();

watch(() => props.title, (title) => {
    pageTitle.value = title;
}, { immediate: true });
</script>

<template>
    <div class="max-w-3xl mx-auto">
        <Card>
            <CardHeader>
                <CardTitle>{{ title }}</CardTitle>
                <CardDescription v-if="description">
                    {{ description }}
                </CardDescription>
            </CardHeader>
            <CardContent>
                <slot />
            </CardContent>
        </Card>
    </div>
</template>
